import { Link } from 'react-router-dom';
import { services } from '@/mocks/services';

export default function ServicesOverview() {
  const featuredServices = services.slice(0, 3);

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold tracking-widest uppercase text-primary-500 mb-3 block">我们的服务</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            一站式国际化解决方案
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
            六大核心服务板块，全方位助力您的企业征战全球市场
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {featuredServices.map((service) => (
            <Link
              key={service.id}
              to="/services"
              className="group bg-background-100/70 border border-background-200/60 rounded-lg p-6 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100/80 rounded-lg mb-4 group-hover:bg-primary-200/80 transition-colors">
                <i className={`${service.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 font-heading">{service.title}</h3>
              <p className="text-xs text-foreground-400 mb-1">{service.subtitle}</p>
              <p className="text-sm text-foreground-600 leading-relaxed">{service.description}</p>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部服务
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}